import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import React, { useCallback, useRef, useState } from 'react';
import * as Yup from 'yup';
import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getVaidationErrors';
import Buttom from '../../forms/Buttom';
import Input from '../../forms/Input';

import Modal from '../Modal';
import { useAuth } from '../../../hooks/auth';
import { saveCreateNewSubjectLog } from '../../../services/logs';

import {
  postCreateSellerSubject,
  postProviderSubject,
} from '../../../services/api';

import { Container, Bottom, Row, Both } from './styles';

interface IModalProps {
  isOpen: boolean;
  setIsOpen: () => void;
  clearFilter: () => void;
}

const ModalAddSubject: React.FC<IModalProps> = ({
  isOpen,
  setIsOpen,
  clearFilter,
}) => {
  const { user } = useAuth();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const handleSubmit = useCallback(
    async data => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Campo Obrigatório'),
        });
        await schema.validate(data, {
          abortEarly: false,
        });

        if (user.type === 'seller' || user.type === 'seller_content_manager') {
          await postCreateSellerSubject({
            name: data.name,
            sellerId: user?.seller?.id,
          });
        } else if (user.type === 'provider') {
          await postProviderSubject(data.name);
        }

        clearFilter();

        // saveCreateNewSubjectLog({
        //   userId: user.id,
        //   newSubjectName: data.name,
        // });
        if (user.seller?.id) {
          saveCreateNewSubjectLog({
            userId: user.id,
            sellerId: user.seller.id,
            action: 'create_new_subject',
            newSubjectName: data.name,
          });
        } else {
          saveCreateNewSubjectLog({
            userId: user.id,
            action: 'create_new_subject',
            newSubjectName: data.name,
          });
        }

        addToast({
          title: 'Disciplina cadastrada com sucesso!',
          type: 'success',
        });
        setIsOpen();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
          return;
        }
        addToast({
          title: 'Ops...',
          type: 'error',
          description: 'Algo inesperado aconteceu.',
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, setIsOpen, user, clearFilter],
  );
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <Container>
        <h1>Nova Disciplina</h1>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Row>
            <Input
              name="name"
              label="Nome:"
              type="text"
              placeholder="Biologia"
            />
          </Row>
          <Both />
          <button type="submit" hidden>
            submeter
          </button>
        </Form>
        <Bottom>
          <Buttom
            name="cancelar"
            type="button"
            onClick={() => setIsOpen()}
            label="Cancelar"
            outline
          />
          <Buttom
            name="salvar"
            onClick={() => formRef.current?.submitForm()}
            label="Salvar"
            isLoading={loading}
          />
        </Bottom>
      </Container>
    </Modal>
  );
};

export default ModalAddSubject;
